import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config } from "../../shared";




@Injectable({
    providedIn: 'root'
})
export class CashbookSettlementMethodHelperService extends BaseApiTemplateService<any> {

    // https://api.akaun.com/core2/tnt/dm/erp/settlement-method/import-file-helper/backoffice-ep/

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'settlement-method/import-file-helper/' + Core2Config.BACKOFFICE_EP_SUFFIX

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'settlement-method/import-file-helper/' + Core2Config.BACKOFFICE_EP_SUFFIX;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'settlement-method/import-file-helper/' + Core2Config.BACKOFFICE_EP_SUFFIX;
        this.httpClient = http;
    }

}

